import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';
import FormGroup from '../helpers/FormGroup';
import Input from '../helpers/Input';
import FieldError from '../helpers/FieldError';

/**
 * User text input component.
 *
 * @param props {Object}.
 * @param props.label {String} Label of text control.
 * @param props.name {String} Name of text control.
 * @param props.formMode {Function} Form mode (view|edit).
 * @param props.formError {Immutable.Map} Error on form.
 * @param props.selectedUser {Immutable.Map} Selected user.
 * @param props.type {String} Type of control.
 * @param props.className {String} Input class name.
 * @param props.autoComplete {String} Input autocomplete attribute.
 */
const UserInputComponent = ({
  label,
  name,
  formMode,
  className,
  formError,
  selectedUser,
  type = 'text',
  autoComplete,
}) => {
  const id = `${label.replace(/\s/g, '_')}_Input`;
  const disabled = formMode === 'view';
  const error = formMode === 'edit' ? formError.get(name, '') : '';
  const value = selectedUser.get(name, '');
  const inputClassName = disabled ? null : className;

  return (
    <FormGroup className={error ? 'has-error' : ''}>
      <Input
        autoComplete={autoComplete}
        className={inputClassName}
        disabled={disabled}
        id={id}
        label={label}
        name={name}
        type={type}
        value={value}
        showLabel
      />
      <FieldError message={error} />
    </FormGroup>
  );
};

UserInputComponent.propTypes = {
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  formError: PropTypes.instanceOf(Map).isRequired,
  formMode: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  selectedUser: PropTypes.instanceOf(Map).isRequired,
};

export const UserInput = memo(UserInputComponent);
